export default __webpack_public_path__ + "static/flex_video_testimonial-0f26cc99872d82673a63a15d20e8bab2.mp4";